export default "__VITE_ASSET__CA3Z9kf5__"